import { render, staticRenderFns } from "./ReportingComparisonAggregate.vue?vue&type=template&id=e040e6c2&scoped=true"
import script from "./ReportingComparisonAggregate.vue?vue&type=script&lang=js"
export * from "./ReportingComparisonAggregate.vue?vue&type=script&lang=js"
import style0 from "./ReportingComparisonAggregate.vue?vue&type=style&index=0&id=e040e6c2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e040e6c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e040e6c2')) {
      api.createRecord('e040e6c2', component.options)
    } else {
      api.reload('e040e6c2', component.options)
    }
    module.hot.accept("./ReportingComparisonAggregate.vue?vue&type=template&id=e040e6c2&scoped=true", function () {
      api.rerender('e040e6c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/reporting-web/ReportingComparisonAggregate.vue"
export default component.exports